<template>
  <div>
    <NavMenu />
    <div class="page-content">
      <DownloadableElements />
      <WebSiteNews />
      <Career />
    </div>
  </div>
</template>

<script>

import NavMenu from '@/components/NavMenu.vue'
import DownloadableElements from '@/components/DownloadableElements.vue'
import WebSiteNews from '@/components/WebSiteNews.vue'
import Career from '@/components/Career.vue'

export default {
  name: 'ManageContent',
  components: { NavMenu, DownloadableElements, WebSiteNews, Career }
}
</script>

<style lang="scss" scoped>
.page-content {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  grid-gap: 30px;
  width: 100%;
}
</style>
